import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Order, Portfolio, Side } from './models';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private readonly http = inject(HttpClient);
  readonly portfolio = signal<Portfolio | null>(null);

  load(): Observable<Portfolio> {
    return this.http.get<Portfolio>('/api/portfolio').pipe(tap((book) => this.portfolio.set(book)));
  }

  place(symbol: string, side: Side, quantity: number): Observable<Order> {
    return this.http.post<Order>('/api/orders', { symbol, side, quantity });
  }

  watch(symbol: string): Observable<string[]> {
    return this.http.post<string[]>('/api/watchlist', { symbol }).pipe(
      tap((watchlist) => this.patchWatch(watchlist)),
    );
  }

  unwatch(symbol: string): Observable<string[]> {
    return this.http.delete<string[]>(`/api/watchlist/${symbol}`).pipe(
      tap((watchlist) => this.patchWatch(watchlist)),
    );
  }

  clear(): void {
    this.portfolio.set(null);
  }

  private patchWatch(watchlist: string[]): void {
    const book = this.portfolio();
    if (book) {
      this.portfolio.set({ ...book, watchlist });
    }
  }
}
